import { IRestModel, RestApi, useDownloadApi } from "@nkr/utils/rest-api";
import { SearchParams } from "@nkr/utils/rest-api/types";

export interface ISwabShipmentOrder extends IRestModel {
    id                                      : number,
    batchId                                 : number | null,
    entityType                              : number,
    entityTypeDescription                   : string,
    entityTypeId                            : number,
    orderDate                               : string,
    firstName                               : string,
    lastName                                : string,
    addressLine1                            : string,
    addressLine2                            : string | null,
    city                                    : string,
    stateProvince                           : string,
    postalCode                              : string,
    country                                 : string
};

export const useSwabShipmentOrderApi = () => {
    const instance = new RestApi<ISwabShipmentOrder, ISwabShipmentOrder>(`${__API__}/hla/swab-shipment/order`);
    return instance.makeHooks();
}

export const useDownloadSwabOrdersCsv = () => {
    const instance = useDownloadApi(`${__API__}/hla/swab-shipment/order`, {
        fileName     : (params: SearchParams) => `swab-shipment-batch-${params.batchId}.csv`,
        mimeType     : 'text/csv',
        responseType : 'text'
    });
    
    return instance;
}